function shellQuote(value) {
  return `'${String(value).replace(/'/g, "'\\''")}'`
}

function outputFile(format) {
  return format === 'jpeg' ? 'design.jpg' : 'design.png'
}

function jsFieldsBlock(fields) {
  const entries = Object.entries(fields)
  if (!entries.length) return '    fields: {},'
  const lines = entries.map(([k, v]) => `      "${k}": ${JSON.stringify(v)},`)
  return ['    fields: {', ...lines, '    },'].join('\n')
}

function pyFieldsBlock(fields, indent = '    ') {
  const entries = Object.entries(fields)
  if (!entries.length) return `${indent}"fields": {},`
  const inner = entries.map(([k, v]) => `${indent}    "${k}": ${JSON.stringify(v)},`).join('\n')
  return [
    `${indent}"fields": {`,
    inner,
    `${indent}},`,
  ].join('\n')
}

export function buildStudioApiExample({
  endpoint,
  lang = 'curl',
  url,
  apiKey,
  page = 1,
  format = 'png',
  fields = {},
  uploadFileName = 'image.jpg',
}) {
  const key = apiKey || '<your-api-key>'

  if (endpoint === 'upload') {
    if (lang === 'js') {
      return [
        'const form = new FormData()',
        'form.append("file", fileInput.files[0])',
        '',
        `const res = await fetch("${url}", {`,
        '  method: "POST",',
        '  headers: {',
        `    "X-API-Key": "${key}",`,
        '  },',
        '  body: form,',
        '})',
        '',
        'const { data } = await res.json()',
        'console.log(data.url)',
      ].join('\n')
    }
    if (lang === 'python') {
      return [
        'import requests',
        '',
        `r = requests.post(`,
        `    "${url}",`,
        `    headers={"X-API-Key": "${key}"},`,
        `    files={"file": open("${uploadFileName}", "rb")},`,
        ')',
        'print(r.json()["data"]["url"])',
      ].join('\n')
    }
    return [
      'curl --request POST \\',
      `  --url "${url}" \\`,
      `  --header "X-API-Key: ${key}" \\`,
      `  --form "file=@${uploadFileName}"`,
    ].join('\n')
  }

  if (endpoint === 'downloadPost') {
    const payload = JSON.stringify({ page, format, fields }, null, 2)
    const out = outputFile(format)
    if (lang === 'js') {
      return [
        `const res = await fetch("${url}", {`,
        '  method: "POST",',
        '  headers: {',
        '    "Content-Type": "application/json",',
        `    "X-API-Key": "${key}",`,
        '  },',
        '  body: JSON.stringify({',
        `    page: ${page},`,
        `    format: "${format}",`,
        jsFieldsBlock(fields),
        '  }),',
        '})',
        '',
        'const blob = await res.blob()',
      ].join('\n')
    }
    if (lang === 'python') {
      return [
        'import requests',
        '',
        `r = requests.post(`,
        `    "${url}",`,
        `    headers={"X-API-Key": "${key}"},`,
        '    json={',
        `        "page": ${page},`,
        `        "format": "${format}",`,
        pyFieldsBlock(fields, '        '),
        '    },',
        ')',
        `open("${out}", "wb").write(r.content)`,
      ].join('\n')
    }
    return [
      'curl --request POST \\',
      `  --url "${url}" \\`,
      `  --header "X-API-Key: ${key}" \\`,
      '  --header "Content-Type: application/json" \\',
      `  --data ${shellQuote(payload)} \\`,
      `  --output ${out}`,
    ].join('\n')
  }

  if (endpoint === 'list') {
    if (lang === 'js') {
      return [
        `const res = await fetch("${url}", {`,
        '  headers: {',
        `    "X-API-Key": "${key}",`,
        '  },',
        '})',
        '',
        'const { data } = await res.json()',
        'console.log(data.designs)',
      ].join('\n')
    }
    if (lang === 'python') {
      return [
        'import requests',
        '',
        `r = requests.get(`,
        `    "${url}",`,
        `    headers={"X-API-Key": "${key}"},`,
        ')',
        'print(r.json()["data"]["designs"])',
      ].join('\n')
    }
    return [
      'curl --request GET \\',
      `  --url "${url}" \\`,
      `  --header "X-API-Key: ${key}"`,
    ].join('\n')
  }

  // meta
  if (lang === 'js') {
    return [
      `const res = await fetch("${url}", {`,
      '  headers: {',
      `    "X-API-Key": "${key}",`,
      '  },',
      '})',
      '',
      'const { data } = await res.json()',
      'console.log(data.design.fields)',
    ].join('\n')
  }
  if (lang === 'python') {
    return [
      'import requests',
      '',
      `r = requests.get(`,
      `    "${url}",`,
      `    headers={"X-API-Key": "${key}"},`,
      ')',
      'design = r.json()["data"]["design"]',
      'print(design["fields"])',
    ].join('\n')
  }
  return [
    'curl --request GET \\',
    `  --url "${url}" \\`,
    `  --header "X-API-Key: ${key}"`,
  ].join('\n')
}
